import { useMutation } from '@tanstack/react-query';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useApi } from '@issuemanager/api-client';

export function useUploadAttachment() {
  const api = useApi();

  return useMutation<
    undefined,
    ExtendedAxiosError,
    { url: string; attachment: File }
  >({
    mutationKey: ['highbond-drive', 'upload'],
    mutationFn: async ({ url, attachment }) => {
      const urlObj = new URL(url);
      const domain = urlObj.hostname;
      const tld = domain.split('.').pop();

      if (tld === 'test') {
        const fakeUpload = new Promise<undefined>((resolve) => {
          setTimeout(() => {
            resolve(undefined);
          }, 1000);
        });
        return fakeUpload;
      }
      return api.axios.put(url, attachment, {
        withCredentials: false,
        headers: {
          'Content-Type': attachment.type,
        },
      });
    },
  });
}
